<template>
  <div>
    <el-row>
      <el-col>
        <!-- <el-button v-show="fun_dic[1002701]" size="small" @click="addWZ">新增</el-button> -->
        <el-button size="medium" @click="addWZ">新增</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe style="width: 100%;margin-top:20px">
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="NAME" label="名称"></el-table-column>
          <el-table-column prop="WZ_DESC" label="描述"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <!-- <el-button v-show="fun_dic[1002702]" type="text" size="small" icon="el-icon-close" @click="deletedData(scope.row)" style="color:#F56C6C">删除</el-button> -->
              <el-button type="text" size="small" icon="el-icon-close" @click="deletedData(scope.row)"
                style="color:#F56C6C">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 新增温区模态框 -->
    <el-dialog title="新增温区" center :visible.sync="addVisible" width="500px" :close-on-click-modal="false"
      @close="close()">
      <el-form :model="addForm" ref="addForm" size="small" :rules="rules">
        <el-form-item label="名称：" :label-width="formLabelWidth" prop="NAME">
          <label slot="label">名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</label>
          <el-input v-model="addForm.NAME" style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="描述：" :label-width="formLabelWidth" prop="DESC">
          <label slot="label">描&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;述：</label>
          <el-input v-model="addForm.DESC" style="width:80%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" @click="submitAdd('addForm')" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  addWQFun, deleteWQ, queryWQ,
} from '@/assets/api/skuManage';
import { frontEndFun } from '@/assets/api/frontFun';

export default {
  data() {
    return {
      PAGE_ID: '10027', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 1002701: 0, 1002702: 0 },
      formLabelWidth: '120px',
      rules: {
        NAME: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        DESC: [
          { required: true, message: '请输入描述', trigger: 'blur' },
        ],
      },
      addForm: {},
      addVisible: false,
      loading: false,
      searchForm: {},
      tableData: [],
    };
  },
  created() {
    this.queryBeforeFun();
    this.queryTable();
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 拉取
    queryTable() {
      queryWQ()
        .then((result) => {
          if (result.length) {
            this.tableData = result;
          } else {
            this.$message.show({ text: '暂无数据', type: 'success' });
            this.tableData = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 新增
    addWZ() {
      this.addVisible = true;
    },
    // 取消
    close() {
      this.addVisible = false;
      this.addForm = {};
    },
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          const params = {
            WZ_NAME: this.addForm.NAME,
            WZ_DESC: this.addForm.DESC,
          };
          addWQFun(params)
            .then((result) => {
              this.$message.show({ text: '新增成功', type: 'success' });
              this.addVisible = false;
              this.addForm = {};
              this.queryTable();
              this.loading = false;
            }).catch((error) => {
              this.loading = false;
              this.$message.show({ text: error, type: 'error' });
            });
        }
      });
    },
    // 删除
    deletedData(row) {
      this.$confirm('确定删除此温区吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          WZ_ID: row.ID,
        };
        deleteWQ(params)
          .then((result) => {
            this.$message.show({ text: '删除成功', type: 'success' });
            this.queryTable();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '已取消删除' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/warehouseManage/temZoneManage.vue